import { useQuery } from "@tanstack/react-query";
import { queryKeys, spacesService } from "@/services";
import type { Space } from "@/types";

interface UseSpacesReturn {
  data: Space[];
  loading: boolean;
  error: Error | null;
}

export const useSpaces = (): UseSpacesReturn => {
  const query = useQuery({
    queryKey: queryKeys.spaces.all,
    queryFn: () => spacesService.getAll(),
  });

  return {
    data: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error : null,
  };
};
